import React, { useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AiFillHome } from "react-icons/ai";
import { FaCalendarAlt, FaUsers } from "react-icons/fa";
import { MdPayment } from "react-icons/md";
import { getRecentPayments } from "../redux/actions/payment";
import { useDispatch, useSelector } from 'react-redux';
import swal from "sweetalert";

export default function BottomNav({ color, color1, color2, color3 }) {
  const dispatch = useDispatch();
  const location = useLocation();
  let user = JSON.parse(localStorage.getItem('userInfo'));
  const { loading, success, data } = useSelector(state => state.getRecentPayments);

  function playAudio() {
    new Audio('/audio/beep.mp3').play();
  }

  useEffect(() => {
    const maxPopups = 3;
    const currentDate = new Date().toDateString();
    const popupCount = JSON.parse(localStorage.getItem('popupCount')) || {};

    if (!popupCount[currentDate]) {
      popupCount[currentDate] = 0;
    }

    if (popupCount[currentDate] < maxPopups) {
      dispatch(getRecentPayments(user && user.id ? user.id : ''));

      const todayTransactions = data?.recent_trans?.filter(transaction =>
        new Date(transaction.created).toDateString() === currentDate
      );

      const recentTransaction = todayTransactions?.find(transaction => transaction.paid === 'yes');
      if (recentTransaction) {
        swal({
          text: "Your Payment Receipt is ready!",
          title: "Payment Receipt",
          icon: "success",
          buttons: {
            view: {
              text: "View",
              value: "view",
              className: "swal-button--view"
            },
            close: {
              text: "Close",
              value: "close",
              className: "swal-button--close"
            }
          }
        }).then((value) => {
          if (value === "view") {
            viewReceipt(recentTransaction.session_id);
          }
        });
        playAudio();
        // Increment the popup count for the day
        popupCount[currentDate] += 1;
        localStorage.setItem('popupCount', JSON.stringify(popupCount));
      }
    }
  }, []);

  const navigate = useNavigate();

  const viewReceipt = (session_id) => {
    navigate("/payment_receipt/" + session_id);
  }

  // Helper function to determine if a route is active
  const isActive = (path) => {
    return location.pathname === path;
  };

  // Navigation items configuration
  const navItems = [
    {
      path: "/homedashboard",
      icon: AiFillHome,
      label: "Home",
      colorProp: color
    },
    {
      path: "/appointment",
      icon: FaCalendarAlt,
      label: "Appointment",
      colorProp: color1
    },
    {
      path: "/queue-wait",
      icon: FaUsers,
      label: "Queue",
      colorProp: color2
    },
    {
      path: "/payment",
      icon: MdPayment,
      label: "Transactions",
      colorProp: color3
    }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      {/* Background with blur effect */}
      <div className="absolute inset-0 bg-white/95 backdrop-blur-lg border-t border-gray-200/50"></div>
      
      {/* Navigation content */}
      <div className="relative px-4 py-3">
        <div className="flex justify-between items-center max-w-md mx-auto">
          {navItems.map((item, index) => {
            const Icon = item.icon;
            const active = isActive(item.path);
            const hasCustomColor = item.colorProp;
            
            return (
              <Link key={index} to={item.path} className="flex-1">
                <div className={`
                  flex flex-col items-center justify-center py-2 px-3 rounded-2xl transition-all duration-300 transform
                  ${active 
                    ? 'bg-gradient-to-br from-primary100/20 to-secondary100/20 scale-105' 
                    : 'hover:bg-gray-50 hover:scale-105'
                  }
                `}>
                  {/* Icon container with enhanced styling */}
                  <div className={`
                    p-2 rounded-xl transition-all duration-300 mb-1
                    ${active 
                      ? 'bg-primary100 shadow-lg' 
                      : 'bg-transparent'
                    }
                  `}>
                    <Icon 
                      className={`
                        text-xl transition-all duration-300
                        ${active 
                          ? 'text-white' 
                          : hasCustomColor 
                            ? hasCustomColor 
                            : 'text-gray-400 hover:text-gray-600'
                        }
                      `} 
                    />
                  </div>
                  
                  {/* Label with enhanced typography */}
                  <p className={`
                    text-xs font-semibold transition-all duration-300
                    ${active 
                      ? 'text-primary100' 
                      : hasCustomColor 
                        ? hasCustomColor.replace('text-', 'text-') 
                        : 'text-gray-500'
                    }
                  `}>
                    {item.label}
                  </p>
                  
                  {/* Active indicator dot */}
                  {active && (
                    <div className="w-1 h-1 bg-primary100 rounded-full mt-1 animate-pulse"></div>
                  )}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
      
      {/* Safe area for devices with home indicator */}
      <div className="h-safe-area-inset-bottom bg-white/95"></div>
    </div>
  );
}
